import { PageHeader } from '../../../../components/Layout';

import UserData from '../../../../components/Common/UserData';

export const Detail = () => {
  return (
    <>
      <PageHeader title="application.profileDetail" />
      <UserData />
    </>
  );
};
